import { DynamicFormAnswer } from '@api_patient/dynamic_forms_api.service';
import { CellulaFormSubmitData } from '@cellula/react';
import type { QuestionApiModel } from '@visiba/api-vcs-client-v2';
import { safeJsonParse } from '@visiba/std';
import { FormQuestionBase } from './_form_question_base';

export class FormQuestionTypeYesNo extends FormQuestionBase {
	public readonly type = 'YesNo';
	public readonly trueLabel: string;
	public readonly falseLabel: string;
	public defaultValue: 'true' | 'false' | undefined = undefined;

	constructor(question: QuestionApiModel) {
		super(question);

		// TODO PAT-426: Allow null?
		this.trueLabel = question.TrueLabel ?? '';
		// TODO PAT-426: Allow null?
		this.falseLabel = question.FalseLabel ?? '';
	}

	// TODO: Use this when not injected anymore...
	// public override getAnswer(formElements: FormElements<string>): AnswerApiModel {
	public getAnswer(pageData: CellulaFormSubmitData): DynamicFormAnswer {
		const formValue = pageData[this.id] ?? null;
		const value = safeJsonParse<boolean | null>(formValue);

		return this.createAnswerApiModel({
			boolValue: value,
		});
	}

	// TODO: Use this when not injected anymore...
	// public override setDefault(allAnswers: Readonly<AnswerApiModel[]>): void {
	public setDefault(allAnswers: Readonly<DynamicFormAnswer[]>): void {
		const answer = allAnswers.find((answer) => answer.questionId === this.composeQuestionId());
		if (answer?.boolValue === false) {
			this.defaultValue = 'false';
		} else if (answer?.boolValue) {
			this.defaultValue = 'true';
		} else {
			this.defaultValue = undefined;
		}
	}
}
